export interface DateInterface {
    dataString(data: Date | string | number | undefined): string;

    dataMinuteString(data: Date | string | number | undefined): string;
}


export let DateUtils: DateInterface = {
    dataString(data: Date | string | number | undefined): string {
        data = getDate(data);
        let _month:any = data.getMonth() + 1;
        if (_month < 10) {
            _month = '0' + _month;
        }
        return `${data.getDate()}/${_month}/${data.getFullYear()}`;
    },
    dataMinuteString(data: Date | string | number | undefined): string {
        data = getDate(data);
        return `${data.getFullYear()}/${data.getMonth() + 1}/${data.getDate()} ${data.getHours()}:${data.getMinutes()}`;
    }
}


function getDate(data: Date | string | number | undefined): Date {
    if (data === undefined) return new Date();
    if (typeof data === "string") data = new Date(data);
    if (typeof data === "number") data = new Date(data);
    return data;
}
